module.exports = __webpack_public_path__ + "static/media/Create.3c0999db.jpg";